"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChartContainerProProps = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _internals = require("@mui/x-charts/internals");
var _allPlugins = require("../internals/plugins/allPlugins");
const _excluded = ["initialZoom", "zoomData", "onZoomChange", "plugins", "apiRef"];
const useChartContainerProProps = (props, ref) => {
  const _ref = props,
    {
      initialZoom,
      zoomData,
      onZoomChange,
      plugins,
      apiRef
    } = _ref,
    baseProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const {
    chartDataProviderProps,
    chartsSurfaceProps,
    children
  } = (0, _internals.useChartContainerProps)(baseProps, ref);
  const chartDataProviderProProps = (0, _extends2.default)({}, chartDataProviderProps, {
    initialZoom,
    zoomData,
    onZoomChange,
    apiRef,
    plugins: plugins ?? _allPlugins.DEFAULT_PLUGINS
  });
  return {
    chartDataProviderProProps,
    chartsSurfaceProps,
    children
  };
};
exports.useChartContainerProProps = useChartContainerProProps;